import React from 'react';
import { ModalBody, ModalHeader, ModalFooter } from '../modal-helpers';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import TextInput from '../../components/TextInput';
import { noop } from 'lodash/fp';
import './ShareBotModal.scss';

type OuterProps = {
  closeModal: Function;
  botSearchToken: string;
};

const ShareBotModal = ({ closeModal, botSearchToken }: OuterProps) => (
  <div className="share-bot-modal">
    <ModalHeader className="share-bot-modal__header">
      <span className="share-bot-modal__header-content">Share this bot</span>
    </ModalHeader>

    <ModalBody className="share-bot-modal__container">
      <div>
        <b>Share via Template Code</b>
      </div>
      <div className="share-bot-modal__help-text">
        You'll be able to share this code with several recipients
      </div>
      <div className="share-bot-modal__input-group">
        <div className="share-bot-modal__text-input-container">
          <TextInput
            className="share-bot-modal__text-input"
            value={botSearchToken}
            onChange={noop}
          />
        </div>
        <CopyToClipboard text={botSearchToken}>
          <Button className="share-bot-modal__copy-button">Copy</Button>
        </CopyToClipboard>
      </div>
    </ModalBody>

    <ModalFooter className="share-bot-modal__footer">
      <Button onClick={closeModal}>OK</Button>
    </ModalFooter>
  </div>
);

export default ShareBotModal;
